import { sipUsersWrapper, } from './index';

export const getSipUsersWrapper = () => {
  return sipUsersWrapper;
};
